module.exports = __webpack_public_path__ + "img/user2.b10c7b75.png";